import React, { useEffect } from "react";
import Icon from "components/AppIcon";

const CrimeResultToast = ({ result, onDismiss }) => {
  useEffect(() => {
    if (!result) return;
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [result, onDismiss]);

  if (!result) return null;

  const isSuccess = result?.success;
  const color = isSuccess ? "var(--color-success)" : "var(--color-error)";
  const glow = isSuccess ? "var(--glow-success)" : "var(--glow-error)";

  return (
    <div
      className="fixed top-6 right-6 z-50 w-80 rounded-xl p-4 flex items-start gap-3 animate-pulse"
      style={{ background: "var(--color-card)", border: `1px solid ${color}50`, boxShadow: glow }}
    >
      <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${color}18` }}>
        <Icon name={isSuccess ? "CheckCircle" : "XCircle"} size={20} color={color} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-heading text-sm font-bold mb-0.5" style={{ color }}>{isSuccess ? "Crime Successful!" : "Crime Failed!"}</div>
        <p className="font-caption text-xs text-muted-foreground leading-relaxed">{result?.message}</p>
        {isSuccess && (
          <div className="flex gap-3 mt-1.5">
            <span className="font-caption text-xs" style={{ color: "var(--color-primary)" }}>+${result?.profit?.toLocaleString()}</span>
            <span className="font-caption text-xs" style={{ color: "var(--color-accent)" }}>+{result?.xp} XP</span>
          </div>
        )}
        {!isSuccess && (
          <span className="font-caption text-xs" style={{ color: "var(--color-error)" }}>Jailed for {result?.jailTime} minutes</span>
        )}
      </div>
      <button onClick={onDismiss} className="flex-shrink-0 hover:opacity-70 transition-opacity">
        <Icon name="X" size={14} color="var(--color-muted-foreground)" />
      </button>
    </div>
  );
};

export default CrimeResultToast;